import axios from "axios";
import { retrieveFromStorage, saveToStorage } from "../Components/Functions";
import { routers } from "../Constants/routers";
import { USER_AUTHENTICATION_DATA } from "../Redux/User/types";

export const authentication = retrieveFromStorage(USER_AUTHENTICATION_DATA);
// export const base = window.location.hostname.includes("localhost") ? "http://localhost:8000/api/v1" : "https://evokeeclinic.herokuapp.com/api/v1" ;
export const base = "https://asess-econsult.herokuapp.com/api/v1" ;
// export const base = "http://localhost:8000/api/v1";


class Api {

    getHeaders = (hds={}) => {
        let headers = {
            "Content-Type": "application/json",
            Accept: "*/*",
            ...hds
        };
        if(authentication?.access){
            const head = { headers: { 
                ...headers, 
                Authorization: `Bearer ${authentication?.access}`}};
            return head;
        }
        return { headers };
    };

    refreshToken = async () => {
        const refresh = await this.post({endpoint: "token/refresh", data: { refresh: authentication?.access }});
        if(refresh?.access) {
            saveToStorage({
                name: USER_AUTHENTICATION_DATA,
                value: {
                    ...authentication,
                    access: refresh?.access,
                    refreshed: true
                }
            })
        }else{
            saveToStorage({
                name: USER_AUTHENTICATION_DATA,
                value: {}
            })
            window.location = routers.auth.login
        }
    }

    formatEndpoint = (endpoint) => {
        if(endpoint[0] !== "/") return "/"+endpoint;
        return endpoint;
    }

    // Request handlers

    formatValidationError = (obj) => {
        try {
            let message = "";
            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    message = `${message}${key.toUpperCase()}: ${obj[key].join("<br/>")}`
                }
            }
            return { message }
        } catch (error) {
            
        }
        return obj;
    }
    

    post = async (props) => {
        const { endpoint = "", data = {}, headers = {} } = props;
        try {
            const res = await axios.post(base+this.formatEndpoint(endpoint), data, this.getHeaders(headers));
            return res?.data;
        } catch (error) {
            if(error?.response?.data?.code === "token_not_valid"){
                await this.refreshToken();
                return await this.post({ ...props, refreshed: true })
            }
            // return error?.response?.data || { detail: error?.message };
            return error?.response?.data ? this.formatValidationError(error?.response?.data) : { detail: error?.message };
        }
    }

    get = async (props) => {
        const { endpoint = "", data = {}, headers = {} } = props;
        try {
            const res = await axios.get(base+this.formatEndpoint(endpoint)+"?"+new URLSearchParams(data).toString(), this.getHeaders(headers));
            return res?.data;
        } catch (error) {
            if(error?.response?.data?.code === "token_not_valid"){
                await this.refreshToken();
                return await this.get({ ...props, refreshed: true })
            }
            return error?.response?.data ? this.formatValidationError(error?.response?.data) : { detail: error?.message };
        }
    }

    put = async ({ endpoint = "", data = {} }) => {
        try {
            const res = await axios.put(base+this.formatEndpoint(endpoint), data, this.getHeaders());
            return res?.data;
        } catch (error) {
            // return error?.response?.data || { detail: error?.message };
            return error?.response?.data ? this.formatValidationError(error?.response?.data) : { detail: error?.message };
        }
    }

    del = async ({ endpoint = "", data = {} }) => {
        const res = await axios.delete(base+this.formatEndpoint(endpoint), {headers: this.getHeaders()['headers'],  data: data});
        return res?.data;
    }

}

export default Api;